import { render, staticRenderFns } from "./SocialDeliverableCampaigns.vue?vue&type=template&id=b60e6444&scoped=true&"
import script from "./SocialDeliverableCampaigns.vue?vue&type=script&lang=js&"
export * from "./SocialDeliverableCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./SocialDeliverableCampaigns.vue?vue&type=style&index=0&id=b60e6444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60e6444",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b60e6444')) {
      api.createRecord('b60e6444', component.options)
    } else {
      api.reload('b60e6444', component.options)
    }
    module.hot.accept("./SocialDeliverableCampaigns.vue?vue&type=template&id=b60e6444&scoped=true&", function () {
      api.rerender('b60e6444', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialDeliverableCampaigns.vue"
export default component.exports